"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasPopMessage = exports.shouldDisplayPopMessage = exports.shouldDoPopCall = exports.shouldDisplayPayButtonAtPopLevel = void 0;
var transactionService_1 = require("./transactionService");
var billingAccountsService_1 = require("./billingAccountsService");
/**
 * Indicates whether the pay button should be displayed at PoP level.
 * Cf. https://confluenceprd-proximuscorp.msappproxy.net/display/eServicesRevamp/Overview+-+Reskin#Overview-Reskin-5.2.3POPlevel
 */
function shouldDisplayPayButtonAtPopLevel(overdueBalance, balance, pop, billingTransaction, paymentInfo, language) {
    var _a, _b, _c, _d, _e;
    if (overdueBalance === 0 ||
        (0, transactionService_1.hasItemOngoing)(billingTransaction) ||
        (0, transactionService_1.hasAnyOverdueTransactionWithOngoingDd)(billingTransaction)) {
        return false;
    }
    var hasMoreThanOneOpenTransaction = ((_d = (_c = (_b = (_a = billingTransaction.result) === null || _a === void 0 ? void 0 : _a.openTransactions) === null || _b === void 0 ? void 0 : _b.billingDocuments) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 1;
    var hasManualPayment = ((_e = paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.result) === null || _e === void 0 ? void 0 : _e.paymentMethod) !== undefined &&
        (0, billingAccountsService_1.isManualPaymentMethod)(paymentInfo.result.paymentMethod);
    return (hasDirectDebitAndAtleastOneRefusedDirectDebitTransaction(paymentInfo, billingTransaction) ||
        (hasMoreThanOneOpenTransaction &&
            hasManualPayment &&
            balance !== overdueBalance &&
            hasPopMessage(pop, language)));
}
exports.shouldDisplayPayButtonAtPopLevel = shouldDisplayPayButtonAtPopLevel;
function hasDirectDebitAndAtleastOneRefusedDirectDebitTransaction(paymentInfo, billingTransaction) {
    var _a;
    return ((0, billingAccountsService_1.isDirectDebitPaymentMethod)((_a = paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.result) === null || _a === void 0 ? void 0 : _a.paymentMethod) &&
        (0, transactionService_1.isRefusedDirectDebit)(billingTransaction));
}
/**
 * Indicates if the pop call should be triggered.
 * @param overdueBalance
 * @param openTransactions
 * @returns True if pop call should be done.
 */
function shouldDoPopCall(overdueBalance, openTransactions) {
    var hasOverdueBalance = (Number(overdueBalance) || 0.0) > 0;
    return hasOverdueBalance && !(0, transactionService_1.hasAtLeastOneOngoingDocument)(openTransactions);
}
exports.shouldDoPopCall = shouldDoPopCall;
function shouldDisplayPopMessage(pop, language, overdueBalance, openTransactions) {
    return shouldDoPopCall(overdueBalance, openTransactions) && hasPopMessage(pop, language);
}
exports.shouldDisplayPopMessage = shouldDisplayPopMessage;
function hasPopMessage(pop, language) {
    var _a;
    return Boolean((_a = pop.result) === null || _a === void 0 ? void 0 : _a.collectionMessage[language]);
}
exports.hasPopMessage = hasPopMessage;
